import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-access-denied',
  templateUrl: './accessdenied.component.html',
  imports: [RouterLink, ButtonModule],
  standalone: true,
})
export class AccessDeniedComponent {}
